import styled from 'styled-components'

export const SubTitle = styled.div`
  font-size: 1.1rem;
  border-bottom: 1px solid #dee2e6;
  margin: 0.5rem 0 0.5rem;
`
